<!-- Section A: Tipo de Embarque (HEADER selector) -->
<div class="section-card">
    <div class="section-header">
        <mat-icon>category</mat-icon>
        Tipo de Embarque
    </div>

    <div class="section-body">
        <!-- Booking no-OPB: selector interactivo -->
        <mat-radio-group
            *ngIf="!isOpbBooking"
            [formControl]="typeOfShipmentControl"
            class="radio-group"
        >
            <mat-radio-button [value]="TypeOfShipment.Container">
                Contenedor
            </mat-radio-button>
            <mat-radio-button [value]="TypeOfShipment.Pallet">
                Pallet
            </mat-radio-button>
        </mat-radio-group>

        <!-- Booking OPB: visual bloqueado, refleja el valor real del booking (no siempre Contenedor) -->
        <mat-radio-group
            *ngIf="isOpbBooking"
            class="radio-group radio-group--locked"
            [value]="typeOfShipment"
        >
            <mat-radio-button [value]="TypeOfShipment.Container" [disabled]="true">
                Contenedor
            </mat-radio-button>
            <mat-radio-button [value]="TypeOfShipment.Pallet" [disabled]="true">
                Pallet
            </mat-radio-button>
        </mat-radio-group>

        <div *ngIf="isOpbBooking" class="info-badge">
            <mat-icon>info</mat-icon>
            Booking OPB: el tipo de embarque proviene del booking (solo lectura)
        </div>
    </div>
</div>

<!-- Section B: Instructivos de Embarque -->
<div class="accordion-actions-bar">
    <div
        class="pending-containers-badge"
        [class.pending-containers-badge--done]="remainingContainerCount === 0"
        *ngIf="isOpbBooking && pendingContainerCount !== null"
    >
        <mat-icon>{{ remainingContainerCount === 0 ? 'check_circle' : 'inventory_2' }}</mat-icon>
        <span *ngIf="remainingContainerCount > 0">
            <strong>{{ remainingContainerCount }}</strong>
            de {{ pendingContainerCount }} contenedor{{ pendingContainerCount === 1 ? '' : 'es' }} pendiente{{ pendingContainerCount === 1 ? '' : 's' }}
        </span>
        <span *ngIf="remainingContainerCount === 0">
            Todos los contenedores asignados
        </span>
    </div>
    <button mat-raised-button color="primary" (click)="addInstructivoPanel()">
        <mat-icon>add</mat-icon>
        Agregar Instructivo de Embarque
    </button>
</div>

<mat-accordion class="booking-summary-accordion" multi>
    <mat-expansion-panel
        *ngFor="let instrForm of instructivoForms; let idx = index"
        [expanded]="true"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>description</mat-icon>
                &nbsp;Instructivo de Embarque #{{ idx + 1 }}
                <span class="panel-container-chip" *ngIf="totalContainerCountFor(idx) > 0">
                    <mat-icon>widgets</mat-icon>
                    {{ totalContainerCountFor(idx) }} cntr{{ totalContainerCountFor(idx) === 1 ? '' : 's' }}
                </span>
            </mat-panel-title>
            <mat-panel-description>
                <button
                    mat-icon-button
                    color="warn"
                    (click)="$event.stopPropagation(); removeInstructivoPanel(idx)"
                    matTooltip="Eliminar instructivo"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Ref. Cliente / Consignatario / Notificante por instructivo -->
        <div [formGroup]="instrForm" class="panel-parties-section">
            <div class="panel-customer-reference-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Ref. Cliente <span class="required">*</span></mat-label>
                    <input matInput formControlName="customerReference" maxlength="200" />
                    <mat-error *ngIf="instrForm.get('customerReference')?.hasError('required')">
                        Ingrese la referencia del cliente
                    </mat-error>
                    <mat-error *ngIf="instrForm.get('customerReference')?.hasError('maxlength')">
                        Máximo 200 caracteres
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="panel-parties-grid">
                <div class="party-column">
                    <h4>Consignatario <span class="required">*</span></h4>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Seleccionar Consignatario</mat-label>
                        <input
                            matInput
                            formControlName="consigneeName"
                            [matAutocomplete]="consigneeAuto"
                            (focus)="searchConsigneeForPanel(idx, $any($event.target).value || '')"
                            (input)="searchConsigneeForPanel(idx, $any($event.target).value || '')"
                        />
                        <mat-autocomplete
                            #consigneeAuto="matAutocomplete"
                            (optionSelected)="onConsigneeSelected(idx, $event.option.value)"
                        >
                            <mat-option
                                *ngFor="let opt of getConsigneeOptionsFor(idx)"
                                [value]="opt"
                            >
                                {{ (opt.shortName || opt.name || '').trim() }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="instrForm.get('consigneeName')?.touched && instrForm.get('consigneeName')?.hasError('required')">
                            Seleccione un consignatario
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width" *ngIf="instrForm.get('consigneePartyId')?.value">
                        <mat-label>Dirección</mat-label>
                        <input matInput formControlName="consigneeAddress" readonly />
                    </mat-form-field>
                </div>
                <div class="party-column">
                    <h4>Notificante <span class="required">*</span></h4>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Seleccionar Notificante</mat-label>
                        <input
                            matInput
                            formControlName="notifyName"
                            [matAutocomplete]="notifyAuto"
                            (focus)="searchNotifyForPanel(idx, $any($event.target).value || '')"
                            (input)="searchNotifyForPanel(idx, $any($event.target).value || '')"
                        />
                        <mat-autocomplete
                            #notifyAuto="matAutocomplete"
                            (optionSelected)="onNotifySelected(idx, $event.option.value)"
                        >
                            <mat-option
                                *ngFor="let opt of getNotifyOptionsFor(idx)"
                                [value]="opt"
                            >
                                {{ (opt.shortName || opt.name || '').trim() }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="instrForm.get('notifyName')?.touched && instrForm.get('notifyName')?.hasError('required')">
                            Seleccione un notificante
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width" *ngIf="instrForm.get('notifyPartyId')?.value">
                        <mat-label>Dirección</mat-label>
                        <input matInput formControlName="notifyAddress" readonly />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div [formGroup]="instrForm" *ngIf="isContainerShipment() || isPalletShipment()">
            <div *ngIf="getItemsFor(idx).length > 0; else noItems" formArrayName="items">
                <div
                    *ngFor="let itemControl of getItemsFor(idx).controls; let i = index"
                    class="item-card"
                    [formGroupName]="i"
                >
                    <div class="item-header">
                        <div class="item-title">
                            Ítem #{{ itemControl.get('itemNumber')?.value }}
                            <span *ngIf="isPalletShipment()">:
                                <strong>{{ itemControl.get('quantityOfPallets')?.value ?? '—' }} pallet(s)</strong>
                            </span>
                        </div>
                        <div class="item-header-actions">
                            <button
                                mat-icon-button
                                *ngIf="!isOpbBooking"
                                (click)="addSpecies(idx, i)"
                                matTooltip="Agregar especie"
                            >
                                <mat-icon>add_circle_outline</mat-icon>
                            </button>
                            <!--
                                Eliminar ítem: SIEMPRE visible, también en bookings OPB (bug real
                                2026-08). Antes vivía dentro del mismo *ngIf="!isOpbBooking" que
                                "Agregar especie", así que para cualquier booking real quedaba
                                oculto en TODOS los paneles. Con "generación múltiple"
                                (múltiples instructivos por booking), addInstructivoPanel() clona
                                todos los ítems del panel #1 en cada panel nuevo — si el booking
                                tiene contenedores con specs distintas (no se fusionan en un ítem
                                con cantidad ajustable), no había forma de sacar el que no
                                corresponde de un panel. Eliminar un ítem no borra el contenedor
                                del booking: mientras el instructivo no se envíe, el contenedor
                                simplemente vuelve a contar como pendiente (remainingContainerCount
                                se recalcula solo, CA-05).
                            -->
                            <button
                                mat-icon-button
                                (click)="removeItem(idx, i)"
                                matTooltip="Eliminar ítem"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>

                    <ng-container *ngIf="isContainerShipment()">
                        <div class="item-field-row item-field-row--dense">
                            <mat-form-field appearance="outline">
                                <mat-label>Cant. cntrs</mat-label>
                                <input matInput type="number" min="1" formControlName="quantityOfContainers" (change)="clampContainerCount(idx, i)" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo bulto cntr</mat-label>
                                <mat-select formControlName="containerTypeId" placeholder="Elegir…">
                                    <mat-option [value]="null">— Elegir —</mat-option>
                                    <mat-option *ngFor="let row of containerPackageTypes" [value]="row.containerTypeId">{{ row.code }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Tratamiento frío</mat-label>
                                <mat-select formControlName="coldTreatmentIndicatorId" placeholder="Elegir…">
                                    <mat-option [value]="null">— Ninguno —</mat-option>
                                    <mat-option *ngFor="let row of coldTreatmentIndicators" [value]="row.coldTreatmentIndicatorId">{{ row.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Atmósfera</mat-label>
                                <mat-select formControlName="controlledAtmosphereId" placeholder="Elegir…">
                                    <mat-option [value]="null">— Elegir —</mat-option>
                                    <mat-option *ngFor="let row of controlledAtmospheres" [value]="row.controlledAtmosphereId">{{ row.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Parámetros atm.</mat-label>
                                <input matInput formControlName="atmosphereParams" />
                            </mat-form-field>
                        </div>
                        <div class="item-field-row item-field-row--dense">
                            <mat-form-field appearance="outline">
                                <mat-label>Temperatura</mat-label>
                                <input matInput type="number" formControlName="temperatureCelsius" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Un. temp.</mat-label>
                                <mat-select formControlName="temperatureUnit" placeholder="Elegir…">
                                    <mat-option *ngFor="let unit of temperatureUnits" [value]="unit">{{ unit }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Ventilación</mat-label>
                                <input matInput type="number" formControlName="ventilation" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Un. vent.</mat-label>
                                <mat-select formControlName="ventilationUnitId" placeholder="Elegir…">
                                    <mat-option [value]="null">— Elegir —</mat-option>
                                    <mat-option *ngFor="let row of ventilationUnits" [value]="row.ventilationUnitId">{{ row.code }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isPalletShipment()">
                        <div class="item-field-row item-field-row--dense">
                            <mat-form-field appearance="outline">
                                <mat-label>Cantidad de Pallets</mat-label>
                                <input matInput type="number" min="1" formControlName="quantityOfPallets" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo bulto plt</mat-label>
                                <mat-select formControlName="palletTypeId" placeholder="Elegir…">
                                    <mat-option [value]="null">— Elegir —</mat-option>
                                    <mat-option *ngFor="let row of palletPackageTypes" [value]="row.palletTypeId">{{ row.code }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <div formArrayName="species">
                        <div
                            *ngFor="let speciesControl of getSpecies(idx, i).controls; let j = index"
                            class="species-row"
                            [formGroupName]="j"
                        >
                            <div class="species-header">
                                <span class="species-index">Especie {{ j + 1 }}</span>
                                <button
                                    *ngIf="!isOpbBooking"
                                    mat-icon-button
                                    (click)="removeSpecies(idx, i, j)"
                                    matTooltip="Eliminar especie"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                            <div class="species-field-row">
                                <mat-form-field appearance="outline">
                                    <mat-label>Especie</mat-label>
                                    <mat-select
                                        formControlName="speciesId"
                                        [compareWith]="compareNumericOption"
                                        (focus)="onSpeciesFocus()"
                                        (selectionChange)="onSpeciesSelected(idx, i, j, $event.value)"
                                        placeholder="Elegir..."
                                    >
                                        <mat-option [value]="null">Elegir...</mat-option>
                                        <mat-option *ngFor="let opt of speciesCatalog" [value]="opt.speciesId">{{ opt.speciesName }}</mat-option>
                                    </mat-select>
                                    <input type="hidden" formControlName="speciesName" />
                                    <button mat-icon-button matSuffix type="button">
                                        <mat-icon>list</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Variedad</mat-label>
                                    <mat-select
                                        formControlName="varietyId"
                                        [compareWith]="compareNumericOption"
                                        [disabled]="isVarietyDisabled(idx, i, j)"
                                        (selectionChange)="onVarietySelected(idx, i, j, $event.value)"
                                        placeholder="Elegir..."
                                    >
                                        <mat-option [value]="null">Elegir...</mat-option>
                                        <mat-option *ngFor="let opt of getVarietiesFor(idx, i, j)" [value]="opt.varietyId">{{ opt.varietyName }}</mat-option>
                                    </mat-select>
                                    <input type="hidden" formControlName="variety" />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Condición</mat-label>
                                    <mat-select
                                        formControlName="conditionId"
                                        [compareWith]="compareNumericOption"
                                        (focus)="onConditionFocus()"
                                        (selectionChange)="onConditionSelected(idx, i, j, $event.value)"
                                        placeholder="Elegir..."
                                    >
                                        <mat-option [value]="null">Elegir...</mat-option>
                                        <mat-option *ngFor="let cond of conditionCatalog" [value]="cond.conditionId">{{ cond.conditionName }}</mat-option>
                                    </mat-select>
                                    <input type="hidden" formControlName="condition" />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Cant. cajas</mat-label>
                                    <input matInput type="number" formControlName="boxCount" />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Tipo embalaje</mat-label>
                                    <mat-select formControlName="typeOfPackageId" [compareWith]="compareNumericOption" placeholder="Elegir...">
                                        <mat-option [value]="null">Elegir...</mat-option>
                                        <mat-option *ngFor="let row of speciesPackageTypes" [value]="row.typeOfPackageId">{{ row.code }}</mat-option>
                                    </mat-select>
                                    <input type="hidden" formControlName="packageType" />
                                </mat-form-field>
                            </div>

                            <div class="species-field-row">
                                <mat-form-field appearance="outline">
                                    <mat-label>Kilos netos</mat-label>
                                    <input matInput type="number" formControlName="netWeightKgPerBox" />
                                    <mat-error *ngIf="speciesControl.get('netWeightKgPerBox')?.errors as netErr">
                                        <span *ngIf="netErr['required']">Campo obligatorio.</span>
                                        <span *ngIf="!netErr['required'] && netErr['greaterThanZero']">Debe ser mayor que cero.</span>
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Kilos brutos</mat-label>
                                    <input matInput type="number" formControlName="grossWeightKgPerBox" />
                                    <mat-error *ngIf="speciesControl.get('grossWeightKgPerBox')?.errors as grossErr">
                                        <span *ngIf="grossErr['required']">Campo obligatorio.</span>
                                        <span *ngIf="!grossErr['required'] && grossErr['greaterThanZero']">Debe ser mayor que cero.</span>
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Kilos total netos</mat-label>
                                    <input matInput [value]="getTotalNetWeightKg(idx, i, j) | number : '1.2-2'" readonly />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Kilos total brutos</mat-label>
                                    <input matInput [value]="getTotalGrossWeightKg(idx, i, j) | number : '1.2-2'" readonly />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>FOB Unitario</mat-label>
                                    <input matInput type="number" formControlName="fobUnitPrice" />
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>FOB item</mat-label>
                                    <input matInput [value]="getFobItemTotal(idx, i, j) | number : '1.2-2'" readonly />
                                </mat-form-field>
                            </div>

                            <div class="species-field-row">
                                <mat-form-field appearance="outline">
                                    <mat-label>Marca</mat-label>
                                    <input matInput formControlName="brand" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #noItems>
            <div
                class="empty-state"
                [class.empty-state--pending]="
                    form.hasError('cargoItemsRequired') && form.touched
                "
            >
                <ng-container *ngIf="isContainerShipment(); else emptyPalletMsg">
                    No hay ítems. Use el botón «Agregar ítem» para cargar la
                    información de cada contenedor.
                </ng-container>
                <ng-template #emptyPalletMsg>
                    No hay ítems. Use el botón «Agregar ítem» para agregar
                    cada línea de pallets y sus especies.
                </ng-template>
            </div>
        </ng-template>

            <div class="panel-footer" *ngIf="!isOpbBooking">
                <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="addItem(idx)"
                >
                    <mat-icon>add</mat-icon>
                    Agregar Ítem
                </button>
            </div>

        <!-- Antecedentes Financieros por instructivo (antes: sección única global) -->
        <div class="section-card section-card--panel" [formGroup]="instrForm">
            <div class="section-header">
                <mat-icon>receipt</mat-icon>
                Antecedentes Financieros
            </div>

            <div class="section-body">
                <div class="catalog-grid">
                    <mat-form-field appearance="outline">
                        <mat-label>Tipo carga</mat-label>
                        <mat-select
                            formControlName="typeOfCargoId"
                            placeholder="Elegir…"
                        >
                            <mat-option [value]="null">Elegir…</mat-option>
                            <mat-option
                                *ngFor="let item of catalogs.typeOfCargoes"
                                [value]="item.id"
                            >
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Forma pago</mat-label>
                        <mat-select
                            formControlName="methodOfPaymentId"
                            placeholder="Elegir…"
                        >
                            <mat-option [value]="null">Elegir…</mat-option>
                            <mat-option
                                *ngFor="let item of catalogs.methodOfPayments"
                                [value]="item.id"
                            >
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Modalidad venta</mat-label>
                        <mat-select formControlName="modeOfSaleId" placeholder="Elegir…">
                            <mat-option [value]="null">Elegir…</mat-option>
                            <mat-option
                                *ngFor="let item of catalogs.modeOfSales"
                                [value]="item.id"
                            >
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Cláusula venta</mat-label>
                        <mat-select
                            formControlName="clauseOfSaleId"
                            placeholder="Elegir…"
                        >
                            <mat-option [value]="null">Elegir…</mat-option>
                            <mat-option
                                *ngFor="let item of catalogs.clauseOfSales"
                                [value]="item.id"
                            >
                                {{ item.name }}
                                <span *ngIf="item.remarks" class="text-secondary"
                                    >({{ item.remarks }})</span
                                >
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Condición de flete</mat-label>
                        <mat-select
                            formControlName="freightCondition"
                            placeholder="Elegir…"
                        >
                            <mat-option [value]="null">Elegir…</mat-option>
                            <mat-option
                                *ngFor="let item of catalogs.freightConditions"
                                [value]="freightEnumFromCatalogId(item.id)"
                            >
                                {{ item.name }}
                                <span *ngIf="item.remarks" class="text-secondary"
                                    >({{ item.remarks }})</span
                                >
                            </mat-option>
                        </mat-select>
                        <!-- Bloqueada cuando viene con match confiable del booking OPB
                             (isFreightConditionLockedFromBooking() en el componente) -->
                        <mat-hint *ngIf="instrForm.get('freightCondition')?.disabled">
                            <mat-icon inline="true" style="font-size: 14px; vertical-align: text-bottom;">lock</mat-icon>
                            Viene del booking (solo lectura)
                        </mat-hint>
                    </mat-form-field>
                </div>

                <div class="checkbox-row" style="margin-top: 12px; display: flex; align-items: center; gap: 16px;">
                    <mat-checkbox formControlName="palletsChep">Pallets CHEP</mat-checkbox>
                    <mat-form-field
                        *ngIf="instrForm.get('palletsChep')?.value"
                        appearance="outline"
                        style="width: 160px;"
                    >
                        <mat-label>Cant. Pallets CHEP</mat-label>
                        <input
                            matInput
                            type="number"
                            min="0"
                            formControlName="palletsChepQuantity"
                            placeholder="0"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
